var React = require('react');

function RightThin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.44868e-09 1.23913L1.45721 1.65875e-09L6.72861 4.75L12 9.5L1.45721 19L1.44848e-09 17.7609L9.10345 9.5L1.44868e-09 1.23913Z","fill":"#39424A"}));
}

RightThin.defaultProps = {"width":"12","height":"19","viewBox":"0 0 12 19","fill":"none"};

module.exports = RightThin;

RightThin.default = RightThin;
